"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVirtualScrollActions = void 0;
const react_1 = require("react");
const hooks_1 = require("../../../store/hooks");
const selectors_1 = require("../selectors");
const slice_1 = require("../slice");
const useVirtualScrollActions = ({ listKey, request, paramsExist, }) => {
    const dispatch = (0, hooks_1.useAppDispatch)();
    const hasNextPage = (0, hooks_1.useAppSelector)((state) => (0, selectors_1.getHasNextPage)(state, listKey));
    const isNextPageLoading = (0, hooks_1.useAppSelector)((state) => (0, selectors_1.getIsNextPageLoading)(state, listKey));
    const scrollUp = (0, react_1.useCallback)((pageNumber) => {
        if (!paramsExist)
            return;
        dispatch(slice_1.eventsProviderActions.scrollUp({
            listKey,
            request,
            pageNumber,
        }));
    }, [dispatch, listKey, request, paramsExist]);
    const loadNextPage = (0, react_1.useCallback)(() => {
        const requestEnabled = hasNextPage && !isNextPageLoading && paramsExist;
        if (requestEnabled) {
            dispatch(slice_1.eventsProviderActions.fetchEventListNextPage({
                listKey,
                request,
            }));
        }
    }, [dispatch, hasNextPage, isNextPageLoading, listKey, request, paramsExist]);
    const resetEventListScroll = (0, react_1.useCallback)(() => {
        dispatch(slice_1.eventsProviderActions.resetEventListScroll({
            listKey,
        }));
        dispatch(slice_1.eventsProviderActions.pollEventList({
            listKey,
            request,
        }));
    }, [dispatch, listKey, request]);
    const loadPrevPage = (0, react_1.useCallback)(() => {
        if (!paramsExist)
            return;
        dispatch(slice_1.eventsProviderActions.fetchEventListPrevPage({
            listKey,
            request,
        }));
    }, [dispatch, listKey, request, paramsExist]);
    return {
        hasNextPage,
        isNextPageLoading,
        loadPrevPage,
        loadNextPage,
        resetEventListScroll,
        scrollUp,
    };
};
exports.useVirtualScrollActions = useVirtualScrollActions;
//# sourceMappingURL=useVirtualScrollActions.js.map